var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.stepComponent,{tag:"component",attrs:{"data-completed":_setup.hiring,"has-error":_setup.hasError,"loading-password":_setup.loadingPassword},on:{"go-to-next-step":_setup.goToNextStep,"has-error":function($event){_setup.hasError = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }